import type { JSONSchema7 } from 'json-schema';
import { GlobalThemeMapping } from '../../themes';
import { DIALOG_THEME_VARIABLES } from '../../themes/themeVariables';

export const DIALOG_THEME_MAPPING: GlobalThemeMapping<typeof DIALOG_THEME_VARIABLES.colors, never, never> = {
  colors: {
    background_base: [
      '--pds-color-bg-root',
      '--pds-color-bg-active-textarea',
      '--pds-color-bg-webview-header',
      '--webview-root-background',
      '--webview-root-background-dark',
    ],
    background_base_alt: [
      '--pds-color-bg-question',
      '--pds-color-bg-answer-option',
      '--pds-color-icon-answer-unselected',
    ],
    background_neutral_1: '--pds-color-bg-textarea',
    background_neutral_1_hover: ['--pds-color-bg-slider', '--pds-color-bg-audio-speed'],
    background_neutral_2: '--pds-color-bg-checkbox-answer-option',
    primary: ['--pds-color-text-question', '--pds-color-text-textarea', '--pds-color-text-answer-option'],
    primary_on_accent: [
      '--pds-color-text-accent',
      '--pds-color-text-accent-inactive',
      '--pds-color-bg-text-answer',
      '--pds-color-bg-icon-answer-selected',
    ],
    secondary: ['--pds-color-placeholder-textarea', '--pds-color-text-answer-option-inactive'],
    action: ['--pds-color-link', '--webview-header-actions', '--webview-header-actions-dark'],
    border_normal: ['--pds-color-bg-border-active-textarea'],
    accent: [
      '--pds-color-bg-answer',
      '--pds-color-bg-accent',
      '--pds-color-bg-accent-inactive',
      '--pds-color-icon-answer-option',
      '--pds-color-icon-answer-option-hover',
      '--pds-color-media-player',
      '--pds-color-content-icon-answer-selected',
      '--pds-color-text-answer-option-hover',
    ],
    progress_bar_line: ['--webview-progress-bar', '--webview-progress-bar-dark'],
    progress_bar_line_filled: ['--webview-progress-bar-track', '--webview-progress-bar-track-dark'],
  },
  others: {},
  fonts: {},
  custom: {
    '--custom-dialog-button-disabled-opacity': '0.22',
    '--custom-dialog-answer-option-hover-opacity': '0.2',
    '--custom-dialog-answer-option-hover-opacity-dark': '0.4',
    '--custom-dialog-opacity-overlay-color': '255,255,255',
    '--custom-dialog-opacity-overlay-color-dark': '0,0,0',
    '--custom-survey-elements-border-radius': '4px',
  },
} as const;

export const createThemeDialogColorsSchema = (): JSONSchema7 => {
  const properties: Record<string, JSONSchema7> = {};

  for (const key of Object.keys(DIALOG_THEME_VARIABLES.colors)) {
    const description = DIALOG_THEME_VARIABLES.colors[key as keyof typeof DIALOG_THEME_VARIABLES.colors].description;

    properties[key] = {
      type: 'object',
      description: description || ``,
      properties: {
        light: { type: 'string' },
        dark: { type: 'string' },
      },
      required: ['light', 'dark'],
      additionalProperties: false,
    };
  }

  return {
    type: 'object',
    description: 'Абстрактно объявленные названия цветов которые ссылаются на dialog переменные',
    properties,
    additionalProperties: false,
    required: Object.keys(DIALOG_THEME_VARIABLES.colors),
  };
};
